import {Controller} from "@/controllers/Controller";
import {RestService} from "@/services/RestService";

/**
 * Controller for group API
 */
export class CompanyController extends Controller {
    static get(){
        return this.requestBuilder("GET",`/ms-transmission/company/`, true);
    }

    /**
     * Même appel que get() mais sans notification d'erreur : l'échec (token SuperPDP absent ou invalide) signifie
     * simplement que l'entreprise n'est pas associée, ce n'est pas une erreur à afficher à l'utilisateur.
     */
    static getSilently(){
        return (new RestService()).restRequest("GET", `${process.env.VUE_APP_BACK_URL}/ms-transmission/company/`, true, undefined, {'Content-Type': 'application/json'});
    }

    static putTvaRegime(tvaRegime, hasVatOnDebits){
        return this.requestBuilder("PUT",`/ms-transmission/company/tva-regime/`, true, {tvaRegime, hasVatOnDebits});
    }

    static post(){
        return this.requestBuilder("POST",`/ms-transmission/company/`, true);
    }

    static callback(code, state){
        return this.requestBuilder("POST",`/ms-transmission/company/callback/`, true, { code : code, state : state });
    }
}
